import script from "./ListaAnexos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaAnexos.vue?vue&type=script&setup=true&lang=js"

import "./ListaAnexos.vue?vue&type=style&index=0&id=1050f70f&lang=css"

const __exports__ = script;

export default __exports__